module.exports = __webpack_public_path__ + "img/santa-cruz-do-sul.1da7f4d9.png";